import React from 'react';

import { Modal } from 'antd';

import { Termo } from '~/pages/TermoDeAceite';

import { ModalContainer } from './styles';

export default function ModalTermoDeAceite({ visible }) {
  return (
    <Modal
      visible={visible}
      closable={false}
      centered
      footer={null}
      width="1150px"
    >
      <ModalContainer>
        <Termo />
      </ModalContainer>
    </Modal>
  );
}
